import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const dispatcherRouter: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: Layout,
    redirect: 'noredirect',
    meta: {
     hidden: true,
     title:'dispatcher1' // 暂时关闭配送员
    },
    children: [
      {
        path: 'dispatcher',
        component: () => import('@/views/dispatcher/dispatcher.vue'),
        name: 'dispatcher',
        meta: { 
          title: 'dispatcher',
          icon1: 'dispatchernav1',
          icon2: 'dispatchernav2'
        //   hidden: true
        }
      },
    ]
  }
]

export default dispatcherRouter